import api from "api";
import { Dropdown, SelectOption } from "components/dropdown/Dropdown";
import { endpoints } from "config";
import ToastMessage, { toastConfig } from "helpers/ToastMessage/ToastMessage";
import React, { ReactText, SetStateAction, useEffect, useState } from "react";
import MilestoneTaskList from "./MileStoneTaskList";
import { DroppableProvided } from "react-beautiful-dnd";

import minimiseIcon from "assets/Icon_Modal_Cross.png";
import { UnParsedTasksAndMilestones } from "../WorkflowBuilderPage";
// import minimiseIcon from "assets/Icon_Form_Search_02.png";

interface Props {
  templateGatewaysList: SelectOption[];
  workflowId: ReactText | null;
  tempTriggerMilestoneData: List | null;
  setTempTriggerMilestoneData: React.Dispatch<SetStateAction<List | null>>;
  tempTriggerMilestoneId: number | null;
  setTempTriggerMilestoneId: React.Dispatch<SetStateAction<number | null>>;
  tempActionMilestoneData: List | null;
  setTempActionMilestoneData: React.Dispatch<SetStateAction<List | null>>;
  tempActionMilestoneId: number | null;
  setTempActionMilestoneId: React.Dispatch<SetStateAction<number | null>>;
  taskPickerMimised: boolean;
  setTaskPickerMimised: React.Dispatch<SetStateAction<boolean>>;
  setShowAddPage: React.Dispatch<SetStateAction<boolean>>;
  setGatewayId: React.Dispatch<SetStateAction<number | null>>;
  milestonestasksList: List[] | null;
  setMilestonestasksList: React.Dispatch<SetStateAction<List[] | null>>;
  setUnParsedTasksAndMilestones: React.Dispatch<
    SetStateAction<UnParsedTasksAndMilestones | null>
  >;
}
export interface List {
  tasksName: string;
  tasksId: number;
}

const MilestoneTaskPicker: React.FC<Props> = ({
  workflowId,
  templateGatewaysList,
  tempTriggerMilestoneData,
  setTempTriggerMilestoneData,
  tempTriggerMilestoneId,
  setTempTriggerMilestoneId,
  tempActionMilestoneData,
  setTempActionMilestoneData,
  tempActionMilestoneId,
  setTempActionMilestoneId,
  taskPickerMimised,
  setTaskPickerMimised,
  setShowAddPage,
  setGatewayId,
  milestonestasksList,
  setMilestonestasksList,
  setUnParsedTasksAndMilestones,
}) => {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [milestoneList, setMilestoneList] = useState<List[]>([]);
  const [taskList, setTaskList] = useState<List[]>([]);
  const [loaing, setloading] = useState<boolean>(false);

  const fetchLists = async (
    workflowId: ReactText | null,
    gatewaysId: number
  ) => {
    const params =
      workflowId && gatewaysId
        ? { params: { GatewaysId: gatewaysId, WorkflowsId: workflowId } }
        : null;
    if (params) {
      try {
        const res = await api.get(
          endpoints.workflowConfiguration.getTask,
          params
        );
        if (res.status === 200 && res.data.status === "1" && res.data.details) {
          let newTasksAndLists: any[] = [];
          let tempUnParsedTasksAndMilestones: UnParsedTasksAndMilestones = [];

          if (
            res.data.details.milestones &&
            res.data.details.milestones.length > 0
          ) {
            setMilestoneList([...res.data.details.milestones]);

            newTasksAndLists = [
              ...newTasksAndLists,
              ...res.data.details.milestones,
            ];

            tempUnParsedTasksAndMilestones = [
              ...tempUnParsedTasksAndMilestones,
              ...res.data.details.milestones.map((item: any) => {
                if (
                  typeof item === "object" &&
                  item.hasOwnProperty("tasksName") &&
                  item.hasOwnProperty("tasksId")
                ) {
                  return {
                    name: item.tasksName,
                    id: item.tasksId,
                    type: "milestone",
                  };
                } else {
                  return null;
                }
              }),
            ];
          } else {
            setMilestoneList([]);
          }
          if (
            res.status === 200 &&
            res.data.status === "1" &&
            res.data.details
          ) {
            if (res.data.details.tasks && res.data.details.tasks.length > 0) {
              setTaskList([...res.data.details.tasks]);

              newTasksAndLists = [
                ...newTasksAndLists,
                ...res.data.details.tasks,
              ];

              tempUnParsedTasksAndMilestones = [
                ...tempUnParsedTasksAndMilestones,
                ...res.data.details.tasks.map((item: any) => {
                  if (
                    typeof item === "object" &&
                    item.hasOwnProperty("tasksName") &&
                    item.hasOwnProperty("tasksId")
                  ) {
                    return {
                      name: item.tasksName,
                      id: item.tasksId,
                      type: "task",
                    };
                  } else {
                    return null;
                  }
                }),
              ];
            } else {
              setTaskList([]);
            }
          }

          let newMilestonestasksList = milestonestasksList
            ? [...milestonestasksList, ...newTasksAndLists]
            : newTasksAndLists;

          const filterKey = "tasksId";

          newMilestonestasksList = [
            ...new Map(
              newMilestonestasksList.map(item => [item[filterKey], item])
            ).values(),
          ];

          setMilestonestasksList(newMilestonestasksList);

          setUnParsedTasksAndMilestones(
            tempUnParsedTasksAndMilestones.filter(item => item !== null)
          );
          setloading(false);
        }

        if (res.status === 200 && res.data.status === "0") {
          console.log("error");
          setloading(false);
          setMilestoneList([]);
          setTaskList([]);
        }
      } catch (error) {
        console.log(error);
        setMilestoneList([]);
        setTaskList([]);
      }
    }
  };

  useEffect(() => {
    setloading(true);
    if (selectedId && workflowId) {
      fetchLists(workflowId, selectedId);
    } else {
      setloading(false);
    }
  }, [selectedId, workflowId]);

  function handleChange(selectedOption: SelectOption) {
    if (selectedOption.value !== null) {
      setSelectedId(selectedOption.value);
      setGatewayId(selectedOption.value);
    } else {
      setSelectedId(null);
      setGatewayId(null);
    }
  }

  return (
    <div className={`TaskPicker ${taskPickerMimised ? "Minimised" : ""}`}>
      {!taskPickerMimised && (
        <div className="MinimiseIconContainer">
          <img
            src={minimiseIcon}
            alt="Minimise milestones and tasks panel"
            className="MinimiseIcon"
            onClick={() => setTaskPickerMimised(true)}
          />
        </div>
      )}

      <Dropdown
        customClassName="TaskPickerDropdown"
        key={`TemplateGatewayList - ${workflowId}`}
        value={templateGatewaysList.find(v => v.value === selectedId)}
        options={templateGatewaysList}
        onChange={handleChange}
        roundedRectangle
        placeholder="Please pick a gateway template to display tasks..."
        portalMode={true}
        menuPlacement="bottom"
      />
      {milestoneList.length > 0 ? (
        <MilestoneTaskList
          list={milestoneList}
          startIndex={0}
          type="milestone"
          tempTriggerMilestoneData={tempTriggerMilestoneData}
          setTempTriggerMilestoneData={setTempTriggerMilestoneData}
          tempTriggerMilestoneId={tempTriggerMilestoneId}
          setTempTriggerMilestoneId={setTempTriggerMilestoneId}
          tempActionMilestoneData={tempActionMilestoneData}
          setTempActionMilestoneData={setTempActionMilestoneData}
          tempActionMilestoneId={tempActionMilestoneId}
          setTempActionMilestoneId={setTempActionMilestoneId}
          setShowAddPage={setShowAddPage}
        />
      ) : (
        <div className="NoTasksMilestones">No Milestones</div>
      )}
      {taskList.length > 0 ? (
        <MilestoneTaskList
          list={taskList}
          startIndex={milestoneList.length}
          type="task"
          tempTriggerMilestoneData={tempTriggerMilestoneData}
          setTempTriggerMilestoneData={setTempTriggerMilestoneData}
          tempTriggerMilestoneId={tempTriggerMilestoneId}
          setTempTriggerMilestoneId={setTempTriggerMilestoneId}
          tempActionMilestoneData={tempActionMilestoneData}
          setTempActionMilestoneData={setTempActionMilestoneData}
          tempActionMilestoneId={tempActionMilestoneId}
          setTempActionMilestoneId={setTempActionMilestoneId}
          setShowAddPage={setShowAddPage}
        />
      ) : (
        <div className="NoTasksMilestones">No tasks</div>
      )}
    </div>
  );
};

export default MilestoneTaskPicker;
